import React from "react";
import { Grid, Input } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { VirtualSelectorStore } from "../base/VirtualSelectorStore";
import { Accommodation, SearchFilter, Value } from "./utils";

type Props = {
  store: VirtualSelectorStore<SearchFilter, Accommodation, Value>;
};

export function AccommodationSelectorFilter(props: Props) {
  return (
    <Grid container spacing={1} alignItems="flex-end">
      <Grid item xs={12}>
        <Input
          autoFocus
          name="text"
          fullWidth
          placeholder={locale.Search}
          onChange={(e) => props.store.setFilter({ text: e.target.value })}
          value={props.store.filter.text}
        />
      </Grid>
    </Grid>
  );
}
